import React from 'react';
import { IconAgeEstimation } from '@yoti/ui-kit-components-react/globals';
import styles from '@components/result/age-antispoofing/ageAntispoofingResponse.module.scss';
import classNames from 'classnames';
import { RawAgeDisplayer } from './raw-age-displayer/RawAgeDisplayer';
import {
    RangeAgeDisplayerProps,
    Interval,
    RangeAgeDisplayer,
} from './range-age-displayer/RangeAgeDisplayer';

export interface Props extends Omit<RangeAgeDisplayerProps, 'interval'> {
    agePredictionIsValid: boolean;
    interval?: Interval;
}

export const AgeDisplayer: React.FC<Props> = ({ agePredictionIsValid, age, interval }) => (
    <>
        <IconAgeEstimation className={styles['response__icon']} />
        <span className={classNames(styles['response__text'], styles['response__text--bold'])}>
            {'Age estimation:'}
        </span>
        {agePredictionIsValid ? (
            interval ? (
                <RangeAgeDisplayer age={age} interval={interval} data-qa="range-age-displayer" />
            ) : (
                <RawAgeDisplayer age={age} data-qa="raw-age-displayer" />
            )
        ) : (
            <span
                className={classNames(
                    styles['response__text'],
                    styles['response__text--undetermined'],
                )}
                data-qa="no-age-displayer"
            >
                Undetermined*
            </span>
        )}
    </>
);
